import { CreateAdminUser } from '../Modal';
import { useSettingModal } from '../../../../hooks/Context';
import {SettingContextI} from '../../../../types';
import { Button } from '../SettingButton';
import React from 'react';

interface Roles {
    Id: string;
    Name: string;
    NormalizedName: string;
  };
  
  interface ComponentProps {
    data: Roles[] | undefined;
  }
  
const CreateBtn: React.FC<ComponentProps> = ({ data }) => {
    const { setModalContent, setShowModal }: SettingContextI = useSettingModal();

    const onClick = () => {
        setModalContent(<CreateAdminUser roleData={data}/>);
        setShowModal(true);
    };
    
    return (
        <Button onClick={onClick} 
            style={{backgroundColor: "#11643C", cursor: "pointer",
            color: "#fff", border: "none", outline: "none", padding: "15px 20px", borderRadius: "5px"}}
        >
            Create Admin User
        </Button>
    )
};

export default CreateBtn;
